const path = (d: string, box = "0 0 20 20") => (
  <svg viewBox={box} aria-hidden="true">
    <path fill="currentColor" d={d} />
  </svg>
);

export const Icon = {
  settings: path("M8.6 2h2.8l.4 2.1c.5.2 1 .5 1.4.8l2-.7 1.4 2.4-1.6 1.4a5.6 5.6 0 0 1 0 1.6l1.6 1.4-1.4 2.4-2-.7c-.4.3-.9.6-1.4.8L11.4 18H8.6l-.4-2.1c-.5-.2-1-.5-1.4-.8l-2 .7-1.4-2.4L5 12a5.6 5.6 0 0 1 0-1.6L3.4 9 4.8 6.6l2 .7c.4-.3.9-.6 1.4-.8L8.6 2ZM10 7.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6Z"),
  tour: path("M10 2a8 8 0 1 1 0 16a8 8 0 1 1 0-16Zm0 1.5a6.5 6.5 0 1 0 0 13a6.5 6.5 0 1 0 0-13ZM8.2 6.6l5 3.4-5 3.4V6.6Z"),
  meets: path("M4 2h1.5v16H4V2Zm2.5 1h9.5l-2.2 3.5 2.2 3.5H6.5V3Z"),
  week: path("M5 2v2H3.5A1.5 1.5 0 0 0 2 5.5v11A1.5 1.5 0 0 0 3.5 18h13a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 16.5 4H15V2h-1.5v2h-7V2H5Zm-1.5 6h13v8.5h-13V8Z"),
  plan: path("M4 3h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm.5 1.5v11h11v-11h-11ZM6 6.5h8V8H6V6.5Zm0 3h8V11H6V9.5Zm0 3h5V14H6v-1.5Z"),
  lifts: path("M3.5 5H6v10H3.5V5Zm10.5 0h2.5v10H14V5ZM6 9.2h8v1.6H6V9.2ZM1.5 7.5h2v5h-2v-5Zm15 0h2v5h-2v-5Z"),
  sessions: path("M2 9h2V7h1.5v6H4v-2H2V9Zm14.5-2H16v6h-1.5V7h1.5Zm-9-2H9v10H7.5V5Zm3.5 0h1.5v10H11V5Zm5 4h2v2h-2V9Z"),
  builder: path("M13.6 2.6a1.5 1.5 0 0 1 2.1 0l1.7 1.7a1.5 1.5 0 0 1 0 2.1L7.6 16.2 3 17l.8-4.6 9.8-9.8Zm1 1.1-1.4 1.4 1.7 1.7 1.4-1.4-1.7-1.7Zm-2.5 2.5-6.9 6.9-.4 2.1 2.1-.4 6.9-6.9-1.7-1.7Z"),
  groups: path("M5 4.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1.4a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2ZM15 4.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1.4a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2ZM10 10.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1.4a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Z"),
  team: path("M7 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM14 5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 10.5c3 0 5.5 1.6 5.5 4V17h-11v-2.5c0-2.4 2.5-4 5.5-4Zm0 1.5c-2.3 0-4 1.1-4 2.5v1h8v-1c0-1.4-1.7-2.5-4-2.5Zm7-.5c2.4 0 4.5 1.3 4.5 3.3V17H14v-1.5h3v-.7c0-1-1.3-1.8-3-1.8-.4 0-.8 0-1.1.1a5 5 0 0 0-1-1.3c.6-.2 1.3-.3 2.1-.3Z"),
  done: path("M6.3 11.6 2.7 8l1.1-1.1 2.5 2.5 5.9-5.9 1.1 1.1-7 7Z", "0 0 16 16"),
  missed: path("M3.5 7.25h9v1.5h-9z", "0 0 16 16"),
  today: (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <circle cx="8" cy="8" r="3.5" fill="currentColor" />
    </svg>
  ),
  planned: (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <circle cx="8" cy="8" r="4" fill="none" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  trophy: path(
    "M4 2h8v1h2v2a3 3 0 0 1-2.4 2.9A4 4 0 0 1 8.8 10.9V12H11v2H5v-2h2.2v-1.1A4 4 0 0 1 4.4 7.9 3 3 0 0 1 2 5V3h2V2Zm8 2.4V6.3A1.5 1.5 0 0 0 12.6 5V4.4H12ZM3.4 4.4V5a1.5 1.5 0 0 0 .6 1.3V4.4h-.6Z",
    "0 0 16 16",
  ),
  track: path("M6.5 1h3v1.3h-.85v1.1a5.5 5.5 0 1 1-1.3 0V2.3H6.5V1ZM8 4.8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-.6 1.2h1.2v3.05l1.9 1.15-.6 1.03-2.5-1.5V6Z", "0 0 16 16"),
  sheet: (
    <svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true">
      <path fill="currentColor" d="M5 2h7l4 4v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm6 1.5V7h3.5L11 3.5ZM7 10h6v1.4H7V10Zm0 3h6v1.4H7V13Z" />
    </svg>
  ),
};

export function PrBadge({ text, spoken }: { text: string; spoken?: string }) {
  return (
    <span className="pr">
      {Icon.trophy}
      <span aria-hidden="true">{text}</span>
      <span className="sr">{spoken ?? "personal best: " + text}</span>
    </span>
  );
}

